module.exports = __webpack_public_path__ + "img/circuit_mon.d2a1fdfb.png";